module.exports = __webpack_public_path__ + "static/media/cb-icon.6c684dd1.svg";